<template>
  <div id="manning-schedule-crew-container" class="manning-schedule-crew-wrap">
    <scheduler-project-model
      ref="projectmodel"
      :hasScheduleChangedAsync="SchedulerEventHandler"
      :syncFailAsync="syncFailAsync"
      :loadFailAsync="loadFailAsync"
      :eventStore="CrewEventStore"
      :resourceStore="CrewResourceStore"
      :assignmentStore="CrewAssignmentStore"
      :timeRangeStore="CrewTimeRangeStore"
      :transport="transport"
    />

    <!-- スケジューラPro -->
    <bryntum-scheduler-pro
      v-if="schedulerConfig"
      v-bind="schedulerConfig"
      cls="aisea-scheduler"
      :taskEditFeature="taskEditFeature"
      :eventTooltipFeature="eventTooltipFeature"
      :scheduleContextFeature="scheduleContextFeature"
      :eventMenuFeature="eventMenuFeature"
      :eventLayout="eventLayout"
      :eventRenderer="eventRenderer"
      :columns="columns"
      :listeners="listeners"
      :project="project"
      :tbar="tbar"
      ref="scheduler"
    >
    </bryntum-scheduler-pro>
  </div>
</template>
<script>
import { BryntumSchedulerPro } from "@bryntum/schedulerpro-vue";
import { LocaleManager, LocaleHelper, DateHelper } from "@bryntum/schedulerpro";
import "@bryntum/schedulerpro/locales/schedulerpro.locale.Ja.js";

import moment from "moment";

import C from "../Constants";
import transport from "./Transport";

import SchedulerEventHandler from "./SchedulerEventHandler";
import {
  CrewEventStore,
  CrewResourceStore,
  CrewAssignmentStore,
  CrewTimeRangeStore,
} from "./scheduler-stores";

import { createSchedulerConfig } from "../scheduler-config/crew";

import { CustomTaskEdit } from "./components/custom-task-edit";

import EventHelperCrew from "../scheduler-event-helper/crew";

import { getVisibleDate } from "../utils/SchedulerUtil";

import Vue from "vue";

// マスターデータのサービス
import {
  // 船員基本条件マスター
  EnterpriseCrewsBasicConditionsService,
  // 船舶情報マスター
  EnterpriseManningVesselsService,
  // 法人勤務種別サービス
  EnterpriseManningStatusService,
  EnterpriseCrewsService,
} from "../services/master";

import SchedulerProjectModel from "../SchedulerProjectModel.vue";

export default {
  name: "Crews",
  components: {
    BryntumSchedulerPro,
    SchedulerProjectModel,
  },
  data() {
    return {
      SchedulerEventHandler,
      // 現在日時
      nowDate: null,
      // スケジューラ設定
      schedulerConfig: null,
      currentStartDate: null,
      currentEndDate: null,
      // TaskEditのセレクトボックスに表示する下船中様態ステータス一覧
      selectableAhoreStausList: [],
      // Project設定
      project: null,
      transport: transport,
      // スケジューラ設定
      // 年度選択
      selectedYear: null,
      // ヘッダーのタブバー表示設定
      tbar: null,
      // リソース列表示設定
      columns: this.buildColumns(),
      // スケジューラのイベントリスナー
      listeners: {
        beforeTaskEditShow: CustomTaskEdit.handleBeforeTaskEditShow,
      },
      // イベント表示設定
      eventLayout: {
        type: "stack",
        groupBy: "scheduling_status",
        weights: {
          SCHEDULED: 0,
          PLANNING: 1,
        },
      },
      // スケジューラのセル設定
      // セルをマウスオーバしたときに、「...」アイコンを表示
      // クリックした時に、メニュー表示
      scheduleContextFeature: {
        activateOnEvent: true,
        triggerEvent: "hover",
        widget: {
          type: "button",
          cls: "context-button b-blue b-transparent",
          icon: "b-fa b-fa b-fa-ellipsis",
          menuIcon: null,
          menu: {
            items: {
              // TODO: 乗船期間のメニューを追加する時に復活させる
              /*
                            addOnboard: {
                                icon: 'b-fa b-fa-edit',
                                text: '乗船期間',
                            },
                            */
              addOffboard: {
                icon: "b-fa b-fa-arrow-right-from-bracket",
                text: "下船期間",
                onItem: () => {
                  // クリックしたセルのリソースと日時を取得
                  const timelineContext = this.$refs.scheduler.instance
                    .timelineContext;
                  const resource = timelineContext.resourceRecord;
                  const startDate = timelineContext.date;
                  const endDate = moment(startDate)
                    .add(1, "days")
                    .toDate();

                  // 辞令職IDはを検索する。
                  const crewId = resource.id.split("_")[1];
                  const crew = EnterpriseCrewsService.findById(crewId);
                  const crewRole = EnterpriseCrewsService.findAppointmentRoleByDate(
                    crew,
                    startDate
                  );

                  // 辞令職が見つからない場合は、通知を表示して終了
                  if (!crewRole) {
                    this.$vs.notify({
                      title: "辞令職が見つかりませんでした",
                      text: `指定された日付に${crew.name}の辞令職が見つかりませんでした。`,
                      color: "danger",
                    });
                    return;
                  }

                  const enterprise_crew_role_id =
                    crewRole.enterprise_crew_role_id;
                  // 下船中様態のステータスのデフォルト設定(最初のステータスを設定)
                  const statusId = this.selectableAhoreStausList[0].id;
                  const eventModel = EventHelperCrew.newAshoreEvent(
                    startDate,
                    endDate,
                    statusId,
                    enterprise_crew_role_id
                  );
                  // イベント編集ツールチップを表示
                  this.$refs.scheduler.instance.editEvent(eventModel, resource);
                },
              },
              addDayOffRequest: {
                icon: "b-fa b-fa-calendar-days",
                text: "休暇希望",
                onItem: () => {
                  // クリックしたセルのリソースと日時を取得
                  const timelineContext = this.$refs.scheduler.instance
                    .timelineContext;
                  const resource = timelineContext.resourceRecord;
                  const startDate = timelineContext.date;
                  const endDate = moment(startDate)
                    .add(1, "days")
                    .toDate();

                  const eventModel = EventHelperCrew.newDayOffRequestEvent(
                    startDate,
                    endDate
                  );
                  // イベント編集ツールチップを表示
                  this.$refs.scheduler.instance.editEvent(eventModel, resource);
                },
              },
            },
          },
        },
      },
      // イベントを右クリックしたときのメニュー表示設定
      // weightはメニューの表示順
      eventMenuFeature: {
        items: {
          deleteEvent: {
            text: "削除",
            icon: "b-fa b-fa-trash",
            weight: 3,
            onItem: ({ eventRecord }) => {
              // イベントストアを取得
              const scheduler = this.$refs.scheduler.instance;
              const eventStore = scheduler.eventStore;

              // 予定イベントの削除は確認ダイアログを表示
              if (
                eventRecord.scheduling_status === C.SCHEDULING_STATUS.SCHEDULED
              ) {
                this.$vs.dialog({
                  type: "confirm",
                  color: "danger",
                  title: "スケジュールの削除",
                  text: "削除しますがよろしいですか",
                  cancelText: "キャンセル",
                  acceptText: "OK",
                  accept: () => {
                    // 予定イベントの削除
                    eventStore.remove(eventRecord);
                  },
                });
              } else {
                // 予定以外のイベントは確認なしで削除
                eventStore.remove(eventRecord);
              }
            },
          },
          editEvent: false,
          splitEvent: false,
          cutEvent: false,
          copyEvent: false,
          unassignEvent: false,
        },
      },
      // イベントマウスオーバ時のツールチップ表示設定
      eventTooltipFeature: {
        template: data => {
          const { eventRecord } = data;
          // 注意・警戒アラートがある場合は表示
          const alerts = eventRecord.alerts;
          let alertElements = [];
          if (alerts && alerts.length > 0) {
            alertElements.push(`<h5>以下のアラートが発生しています</h5>`);
            alerts.forEach(alert => {
              alertElements.push(`<p style="font-size: 1.2rem; margin: 0;">`);
              const iconColor =
                alert.alert_type === C.EVENT_ALERT_TYPE.CAUTION
                  ? C.EVENT_ALERT_INCON_COLORS.CAUTION
                  : C.EVENT_ALERT_INCON_COLORS.WARNING;
              alertElements.push(
                `<i class="b-icon b-fa-circle-exclamation" style="color:${iconColor};"></i>`
              );
              alertElements.push(alert.message);
              alertElements.push(`</p>`);
            });
          }

          let title = "役職期間";
          if (
            eventRecord.event_type === C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST
          ) {
            title =
              "休暇希望・" +
              C.DAY_OFF_REQUEST_PRIORITY_NAME[eventRecord.priority];
          }

          return `
                <div class="manning-schedule-event-tooltip">
                <h5>${title}</h5>
                <p>
                  ${DateHelper.format(
                    eventRecord.startDate,
                    "YYYY/MM/DD HH:mm"
                  )}
                  -
                  ${DateHelper.format(eventRecord.endDate, "YYYY/MM/DD HH:mm")}
                </p>
                  ${alertElements.join("")}
                </div>`;
        },
      },

      taskEditFeature: {},
    };
  },
  setup() {
    return {
      CrewEventStore,
      CrewResourceStore,
      CrewAssignmentStore,
      CrewTimeRangeStore,
    };
  },
  methods: {
    /**
     * イベント描画設定
     * @param {Object} eventRecord イベントレコード
     * @param {Object} renderData レンダーデータ
     */
    eventRenderer({ eventRecord, renderData }) {
      let eventName = "";

      let textColorStyle = "";

      if (eventRecord.event_type === C.SCHEDULING_EVENT_TYPE.VESSEL) {
        // イベントの色変更
        const COLOR_LIST = ["#028AC7", "#0EA5E9"];
        const eventStore = eventRecord.eventStore;
        const records = eventStore.query(
          record =>
            record.scheduling_status === eventRecord.scheduling_status &&
            eventRecord.resourceId === record.resourceId,
          true
        );
        const idx = records.findIndex(record => record.id === eventRecord.id);

        renderData.eventColor = COLOR_LIST[idx % COLOR_LIST.length];
        // 予定、計画中でスタイルを変更
        // 計画中は透過する。
        renderData.eventStyle =
          eventRecord.scheduling_status === C.SCHEDULING_STATUS.SCHEDULED
            ? "plain"
            : "colored";

        const vessel = EnterpriseManningVesselsService.findById(
          eventRecord.enterprise_manning_vessel_id
        );
        const rolePostion = EnterpriseManningVesselsService.findRolePositionByIds(
          vessel.id,
          eventRecord.enterprise_crew_role_id,
          eventRecord.enterprise_manning_vessel_role_position_id
        );

        const vesselName = vessel ? vessel.name : "";
        const roleName = rolePostion ? rolePostion.name : "";

        eventName = `${vesselName}・${roleName}`;
      }

      // 下船中様態はグレーで表示
      if (eventRecord.event_type === C.SCHEDULING_EVENT_TYPE.ASHORE) {
        renderData.eventColor = "#bababa";
        const status = EnterpriseManningStatusService.findById(
          eventRecord.enterprise_manning_status_id
        );
        eventName = status ? status.name : "";
      }

      // 休暇希望は赤色の線で表示
      if (eventRecord.event_type === C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST) {
        renderData.eventStyle = "line";
        const priority = eventRecord.priority;
        eventName = "休暇希望・" + C.DAY_OFF_REQUEST_PRIORITY_NAME[priority];
        if (priority === C.DAY_OFF_REQUEST_PRIORITY.HIGH) {
          renderData.eventColor = "#F23B2F;";
          textColorStyle = "color: #F23B2F;";
        } else {
          renderData.eventColor = "#FB923C;";
          textColorStyle = "color: #FB923C;";
        }
      }

      renderData.style = "text-align: center;" + textColorStyle;

      // イベントに埋め込むタグ
      let eventTatgs = [
        {
          tag: "span",
          text: eventName,
        },
      ];
      // 注意・警戒アラートがある場合は、イベントにアイコンを表示
      let alerts = eventRecord.alerts;
      if (
        alerts.findIndex(
          alert => alert.alert_type === C.EVENT_ALERT_TYPE.CAUTION
        ) >= 0
      ) {
        eventTatgs.push({
          tag: "i",
          class:
            "vs-icon notranslate icon-scale material-icons small bg-small vs-icon-bg",
          text: "error",
          style: `margin-left: 0.2rem; color: ${C.EVENT_ALERT_INCON_COLORS.CAUTION};`,
        });
      }

      if (
        alerts.findIndex(
          alert => alert.alert_type === C.EVENT_ALERT_TYPE.WARNING
        ) >= 0
      ) {
        eventTatgs.push({
          tag: "i",
          class:
            "vs-icon notranslate icon-scale material-icons small bg-small vs-icon-bg",
          text: "error",
          style: `margin-left: 0.2rem; color: ${C.EVENT_ALERT_INCON_COLORS.WARNING};`,
        });
      }

      return eventTatgs;
    },
    /**
     * タブバーの設定
     * @returns {Array} タブバーの設定
     */
    buildTabbar() {
      return [
        {
          type: "label",
          text: "人単位 配乗表",
          style: "font-weight: bold; color: #000000;",
        },
        {
          type: "button",
          icon: "b-icon b-fa-caret-left",
          onClick: async ({ source }) => {
            this.selectedYear--;
            await this.reloadData();
            // 隣のピッカーを取得して、選択した年度を設定
            const picker = source.nextSibling;
            picker.value = this.selectedYear;
          },
        },
        {
          type: "displayfield",
          ref: "yearLabel",
          value: this.selectedYear,
          cls: "year-label",
        },
        {
          type: "button",
          icon: "b-icon b-fa-caret-right",
          onClick: async ({ source }) => {
            this.selectedYear++;
            await this.reloadData();
            // 隣のピッカーを取得して、選択した年度を設定
            const picker = source.previousSibling;
            picker.value = this.selectedYear;
          },
        },
        {
          type: "button",
          text: "更新",
          onClick: async () => {
            await this.reloadData();
          },
        },
        {
          type: "combo",
          label: "表示単位",
          width: 140,
          align: "center",
          cls: "scale-text-combo",
          editable: false,
          items: [
            { text: "日", value: "day" },
            { text: "週", value: "week" },
            { text: "月", value: "month" },
          ],
          value: "day",
          onAction: ({ value }) => this.onScaleChange(value),
        },
        "->",
        {
          type: "button",
          text: "船舶単位",
          onClick: () => {
            const url = this.$router.resolve({
              name: "addon-crew-assignment-management-manning-schedule-vessels",
            }).href;
            window.open(url, "_blank");
          },
        },
      ];
    },
    /**
     * リソース列の設定
     * @returns {Array} リソース列の設定
     */
    buildColumns() {
      return [
        {
          text: "辞令職",
          field: "appointed_role_name",
          htmlEncode: false,
          editor: false,
          readOnly: true,
          // 6文字 fontsize: 14 * 6文字 + 余白: 14 + 14
          width: 112,
        },
        {
          text: "氏名",
          field: "name",
          htmlEncode: false,
          editor: false,
          readOnly: true,
          // 7文字 fontsize: 14 * 7文字 + 余白: 14 + 14
          width: 126,
        },
        {
          text: "社員区分",
          field: "employment_status",
          htmlEncode: false,
          editor: false,
          readOnly: true,
          // 4文字 fontsize: 14 * 4文字 + 余白: 14 + 14
          width: 84,
        },
      ];
    },

    /**
     * スケジューラの同期失敗時の処理
     * こちらはSchedulerProjectModelから呼び出されるイベントハンドラ
     * @param {Object} response レスポンスオブジェクト
     */
    async syncFailAsync() {
      // 同期失敗時の処理
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "更新に失敗しました",
        text: "データを更新できませんでした。再読込みして下さい。",
        buttonCancel: true,
        acceptText: "再読込み",
        accept: () => {
          // ページをリロード
          this.reloadData();
        },
      });
    },

    /**
     * スケジューラのロード失敗時の処理
     * こちらはSchedulerProjectModelから呼び出されるイベントハンドラ
     * @param {Object} response レスポンスオブジェクト
     */
    async loadFailAsync() {
      // ロード失敗時の処理
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "システムエラー",
        text: "システムエラーが発生しました。管理者へお問い合わせください。",
        buttonCancel: true,
        acceptText: "OK",
      });
    },

    async reloadData() {
      // スケジューラのデータを取得
      this.project = this.$refs.projectmodel.project;
      const projectInstance = this.project.instance;

      const res = await projectInstance.load({
        request: {
          params: {
            fiscal_year: this.selectedYear,
          },
        },
      });

      // 再ロードしてもカレンダーが変わらないので、再設定
      const { startDate, endDate } = res.response.project;
      this.currentStartDate = startDate;
      this.currentEndDate = endDate;

      await this.$refs.scheduler.instance.setTimeSpan(startDate, endDate);

      // 年度ラベルを更新
      this.$refs.scheduler.instance.widgetMap.yearLabel.value = this.selectedYear;
    },

    async onScaleChange(presetId) {
      const schedulerRef = this.$refs.scheduler;
      const scheduler = schedulerRef && schedulerRef.instance;

      let presets = [];
      if (this.schedulerConfig && Array.isArray(this.schedulerConfig.presets)) {
        presets = this.schedulerConfig.presets;
      }

      const presetExists = presets.some(function(preset) {
        return preset.id === presetId;
      });

      if (scheduler && presetExists) {
        scheduler.viewPreset = presetId;
        await this.$refs.scheduler.instance.setTimeSpan(
          this.currentStartDate,
          this.currentEndDate
        );
      } else {
        Vue.$log.warn(
          "スケジューラまたはプリセットが見つかりません",
          scheduler,
          presetId
        );
      }
    },
  },

  async mounted() {
    // スケジューラの設定を作成
    this.schedulerConfig = createSchedulerConfig();

    // 現在日時を設定
    this.nowDate = new Date();

    // スケジューラプロのローカライズ設定
    LocaleManager.locale = LocaleHelper.locales.Ja;

    // マスターデータの読み込み
    // 失敗した場合はダイアログを表示して、ページをリロードする。
    try {
      await Promise.all([
        await EnterpriseCrewsBasicConditionsService.fetch(),
        await EnterpriseManningStatusService.fetch(),
        await EnterpriseManningVesselsService.fetch(),
        await EnterpriseCrewsService.fetch(),
      ]);
    } catch (e) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "システムエラー",
        text: "システムエラーが発生しました。管理者へお問い合わせください。",
        buttonCancel: true,
        acceptText: "OK",
      });
      return;
    }

    this.selectableAhoreStausList = EnterpriseManningStatusService.getSelectableAshoreStatuses();

    this.taskEditFeature = CustomTaskEdit.buildCustomTaskEdit(
      this.selectableAhoreStausList
    );

    // 表示年度を設定してから、タブバーを作成
    // 初回は現在の年度を設定する。
    const fisicalYear = EnterpriseCrewsBasicConditionsService.getFiscalYear(
      this.nowDate
    );
    this.selectedYear = fisicalYear;
    this.tbar = this.buildTabbar();

    // データ読み込み
    await this.reloadData();

    // 現在時刻の線を表示
    this.project.instance.applyChangeset({
      timeRanges: {
        added: [
          {
            id: "nowDate",
            startDate: moment(this.nowDate).format(),
            cls: "b-circle",
          },
        ],
      },
    });

    // カレンダーの初期表示位置の設定
    const visibleDate = getVisibleDate(this.currentStartDate, this.nowDate, 20);
    this.$refs.scheduler.instance.visibleDate = visibleDate;
  },
};
</script>
<style lang="scss" scoped>
@import "~@bryntum/schedulerpro/schedulerpro.stockholm.css";

.manning-schedule-crew-wrap {
  box-sizing: border-box;
  width: 100%;
  height: calc(100vh - (2.2rem * 2));
  position: relative;
}

.manning-schedule-crew-wrap {
  :deep(.b-sch-event-content) {
    right: 0.75em !important;
    margin-left: auto !important;
  }

  /* カレンダーの土日色 */
  :deep(.calendar-saturday) {
    background-color: #b8b8ff;
    color: #fff;
  }

  :deep(.calendar-sunday) {
    background-color: #ffb8b8;
    color: #fff;
  }

  /* 現在日時線 */
  :deep(.b-grid-header .b-sch-line.b-circle.b-sch-timerange) {
    background-color: #ff0000;
    height: 0.8em !important;
    width: 0.8em !important;
    border-radius: 50%;
    margin-inline-start: -0.43em;
    bottom: 0;
    padding: 0;
  }

  :deep(.b-timeline-subgrid .b-sch-line.b-circle) {
    border-left: 2px solid #ff00003a;
  }

  :deep(.year-label) {
    width: 100px;
    height: 42px;
    font-size: 14px;
    color: #4f5964;
    background-color: white;
    border: rgb(208, 209, 210) solid 1px;
    border-radius: 2px;

    span {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
